import React from 'react';
import { PlusIcon } from '@heroicons/react/24/solid';
import Button from '../../Button';

export interface AddButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

/**
 * Domain-specific shim around the canonical <Button> primitive.
 * Renders a primary action with a leading + icon. Use above admin tables
 * for "Add …" affordances.
 */
export default function AddButton({
  onClick,
  children,
  disabled,
  className,
}: AddButtonProps) {
  return (
    <Button
      variant="primary"
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className={className}
      leftIcon={<PlusIcon aria-hidden="true" />}
    >
      {children}
    </Button>
  );
}
